/**
 * @typedef WorkspaceComponentsData
 * @type object
 * @property {number} top   The top offset
 * @property {number} left   The left offset
 * @property {string} connectedTo   The port to which it is connected. It does not exist if not connected to any port
 */

/**
 * It has keys as component types for eg led
 * @example
 * {
 * 	 "led": [{top: 20, left: 80, connectedTo: 'A1'}, ...], ...
 * }
 * @typedef WorkspaceComponents
 * @type object
 * @property {WorkspaceComponentsData[]} ComponentType An array describing components of "ComponentType"
 */

/**
 * Describes a component in workspace. The last 3 properties may or may not be present.
 * (Different from {@link WorkspaceComponents})
 * @typedef AssemblyComponent
 * @type object
 * @property {string} type Type of the component
 * @property {?number} index Index of component in {@link WorkspaceComponents} if old component
 * @property {?number} left The left offset
 * @property {?number} top  The top offset
 * @property {?string} connectedTo Port connected to
 */

/**
 * This module is the workspace component of assembly tab and contains many functions for manipulation of the workspace object
 * This is a drop target.
 * @module components/assembly/Workspace
 */

import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import ItemTypes from './ItemTypes'
import Modal from 'react-modal'

import { DropTarget } from 'react-dnd-old'
import DraggingInfo from './DraggingInfo'

// var cumulativeOffset  from './src/helpers/cumulativeOffset');

import Bibox from './Bibox'
import Component1 from './Component'
import { getHardwareWireConfig, computeAutoDropPinConnections } from './PinMaps'
import Ports from './PortData'
import {
    computeJoystickDropWires,
    getJoystickWireConfig,
    isJoystickWireType,
    resolveConnectedTarget,
} from './PinMaps'
import renderPrgImage from '../../source/programImg'
import { isAi1ShowCondition } from '../../utils/utils'
import { appAiBytesGeneration } from '../AppMode/AppModeAI/AppModeAiBytesGeneration'

var tutorialDesc = ''
//Custom Styles

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        height: '28%',
        width: ' 30%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#9ecee8',
        zIndex: 1,
    },
}
var count = 0

const workspaceTarget = {
    drop(props, monitor, component) {
        sessionStorage.setItem('isSave', JSON.stringify(false))
        const { offset, scale } = props.workspace
        const { width, height } = props
        DraggingInfo.isDragging = false
        const type = monitor.getItemType()
        const item = monitor.getItem()
        var currentOffset
        if (
            monitor.getItemType() === ItemTypes.COMPONENT &&
            !DraggingInfo.draggingComponentOld
        ) {
            currentOffset = monitor.getClientOffset()
        } else currentOffset = monitor.getClientOffset()
        currentOffset.x -= document.body.clientWidth - width
        currentOffset.y -= document.body.clientHeight - height
        currentOffset.x = currentOffset.x / scale - offset.left
        currentOffset.y = currentOffset.y / scale - offset.top
        if (
            type === ItemTypes.COMPONENT &&
            !DraggingInfo.draggingComponentOld
        ) {
            if (document.getElementById('play_shield')) {
                //console.log("playsheild exists");
                return null
            }
            if (document.getElementById('arm_shield')) {
                //console.log("playsheild exists");
                return null
            }
            component.newComponent(item.type, currentOffset.x, currentOffset.y)
        } else {
            if (type === ItemTypes.BIBOX)
                component.moveBibox(currentOffset.x, currentOffset.y)
            else component.updateOldComponent(currentOffset.x, currentOffset.y)
        }
    },
}

let componentsDataSensor = JSON.parse(sessionStorage.getItem('concept')).counter

// var Workspace = React.createClass({
class Workspace extends Component {
    constructor(props) {
        super(props)
        this.workSpaceRef = React.createRef()
        this.boxRef = React.createRef()
        var tutorialPortArray = []
        var selectionType = localStorage.getItem('programMode')

        if (selectionType == 'learn') {
            tutorialDesc = JSON.parse(sessionStorage.getItem('tutorialPort'))
            // tutorialPortArray.push(JSON.parse(tutorialDesc).assembly1)
            // tutorialPortArray.push(JSON.parse(tutorialDesc).assembly2)
        }

        this.state = {
            tutorialDesc: tutorialDesc,
            usbOpen: false,
            detected: false,
            internalAccessoriesData: JSON.parse(
                sessionStorage.getItem('concept')
            ).internalaccessories,
        }
    }

    componentDidMount = () => {
        // Expose this WorkSpace instance so the Assembly state machine can delegate
        // the joystick_v2 wire commit (which needs upDatePortConnectionsRedux).
        window.assemblyWorkspace = this
        /*The followimg code is to position bibox at the centre of viepwoint on initial render if the user is
        starting an new project.This can be detected if the values of top and left are exactly the same as when the
        assembly object was created.

        If it is an existing project,then don't reposition
        */
        console.log('MOVETOMID' + sessionStorage.getItem('assembly'))
        const assembly = JSON.parse(sessionStorage.getItem('assembly'))
        console.log('MOVETOMID' + assembly)
        var leftbox = assembly.workspace.bibox.left
        var topbox = assembly.workspace.bibox.top
        console.log('MOVETOMID' + leftbox + topbox)
        if (leftbox == '328' && topbox == '208') {
            console.log('GROOT')
            this.moveBibox(
                this.workSpaceRef.current
                    ? this.workSpaceRef.current.getBoundingClientRect().width /
                          2 -
                          200
                    : 500,
                this.workSpaceRef.current
                    ? this.workSpaceRef.current.getBoundingClientRect().height /
                          2 -
                          180
                    : 800
            )
        } else {
            console.log('MOOT')
        }

        const { height, width } = this.props
        this.removeConnection = this.removeConnection.bind(this)
        var { PortConnections } = this.props.appState.assembly
        var { components, scale, offset } = this.props.workspace
        var selectedComponents = JSON.parse(
            sessionStorage.getItem('SelectedComp')
        )

        // var arr1 = [],
        // 	arr2 = [];

        // for (var k in components) {
        // 	arr1.push(k);
        // }
        // try {
        // 	for (var k = 0; k < selectedComponents.length; k++) {
        // 		arr2.push(selectedComponents[k].type);
        // 	}
        // } catch (e) {}

        // for (var i = 0; i < arr1.length; i++) {
        //   //console.log("workspacediffffff", difference[i]);
        //   if (arr1[i] != null || undefined) {
        //     console.log("workspace", components[arr1[i]]);
        //     delete components[arr1[i]];
        //   }
        // }
        // 	if (arr2.includes(arr1[i])) {
        // 		console.log("WorkspaceComponents present:", arr1[i]);
        // 	} else {
        // 		delete components[arr1[i]];
        // 	}
        // }

        if (components != null || undefined) {
            var { workspace } = this.props
            workspace.components = components
            this.props.update(workspace)
        }

        PortConnections = this.upDatePortConnectionsRedux()
        this.props.updatePort(PortConnections)
    }

    componentWillUnmount() {
        if (window.assemblyWorkspace === this) window.assemblyWorkspace = null
    }

    /**
     * Commit a single joystick_v2 wire (Roboki) onto `port`. Mutates the
     * component's `wireConnections`, derives `connectedTo`, and pushes the change
     * through the same redux/sessionStorage path drops use. Called by the Assembly
     * state machine (index.js connectWire).
     * @param {string} type   component type ('joystick_v2')
     * @param {number} index  component index
     * @param {string} wireKey 'A' | 'B'
     * @param {string} port   target board port ('A' | 'B')
     */
    setJoystickWire(type, index, wireKey, port) {
        var { workspace } = this.props
        const comp = workspace.components?.[type]?.[index]
        if (!comp) return
        if (!comp.wireConnections) comp.wireConnections = { A: null, B: null }
        comp.wireConnections[wireKey] = port
        comp.connectedTo =
            comp.wireConnections.A || comp.wireConnections.B || undefined
        this.props.update(workspace)
        const PortConnections = this.upDatePortConnectionsRedux()
        this.props.updatePort(PortConnections)
    }

    /**
     * Move the bibox to a new position
     * @param  {number} left The new left
     * @param  {number} top  The new top
     */
    moveBibox(left, top) {
        var { workspace } = this.props
        workspace.bibox.left = left
        workspace.bibox.top = top
        this.props.update(workspace)
    }

    upDatePortConnectionsRedux() {
        var { components } = this.props.workspace
        var { PortConnections } = this.props.appState.assembly
        Object.keys(PortConnections).map(
            (port) => (PortConnections[port] = null)
        )

        Object.keys(components).map((type) => {
            components[type].map((component, index) => {
                // let SensorObj = componentsDataSensor.find((o) => o.type === type);
                if (!component.connectedTo) return
                if (type == 'dual_splitter') {
                    if (component.connectedTo) {
                        if (
                            component.connectedTo == 'A' ||
                            component.connectedTo == 'B' ||
                            component.connectedTo == 'C' ||
                            component.connectedTo == 'D' ||
                            component.connectedTo == 'E' ||
                            component.connectedTo == 'F'
                        ) {
                            PortConnections[component.connectedTo] = {
                                type,
                                index,
                            }
                        }
                    }
                } else if (type == 'pcAiTool') {
                    if (component.connectedTo) {
                        PortConnections['A'] = {
                            type,
                            index,
                        }
                        PortConnections['A1'] = {
                            type,
                            index,
                        }
                        PortConnections['ai_LEDA1'] = {
                            type,
                            index,
                        }
                        PortConnections['ai_audioA1'] = {
                            type,
                            index,
                        }
                    }
                } else if (type == 'OLED') {
                    if (component.connectedTo) {
                        PortConnections[component.connectedTo] = {
                            type,
                            index,
                        }

                        if (
                            !['Poki', 'Roboki', 'woofKit'].includes(
                                sessionStorage.getItem('connectedDevice')
                            )
                        ) {
                            PortConnections[`${component.connectedTo}1`] = {
                                type,
                                index,
                            }
                        }

                        PortConnections['OLEDOne'] = {
                            type,
                            index,
                        }
                        PortConnections['OLEDTwo'] = {
                            type,
                            index,
                        }
                        PortConnections['OLEDThree'] = {
                            type,
                            index,
                        }
                    }
                } else if (
                    [
                        'dc_motor',
                        'mini_geared_motor',
                        'geared_motor',
                        'dynamex_motor',
                    ].includes(type)
                ) {
                    if (component.connectedTo) {
                        // armShield M1 (doesnt really mean M1) is actually M2 and M3.
                        const isArmSHield =
                            sessionStorage.getItem('armShield') == 'true' ||
                            false
                        const isPeeCeeATR =
                            sessionStorage.getItem('peeCeeATR') == 'true' ||
                            false

                        if (isPeeCeeATR) {
                            if (component.connectedTo == 'M1' && isPeeCeeATR) {
                                PortConnections['M1'] = {
                                    type,
                                    index,
                                }
                                PortConnections['M2'] = {
                                    type,
                                    index,
                                }
                            } else if (
                                component.connectedTo == 'M3' &&
                                isPeeCeeATR
                            ) {
                                PortConnections['M3'] = {
                                    type,
                                    index,
                                }
                                PortConnections['M4'] = {
                                    type,
                                    index,
                                }
                            } else if (
                                component.connectedTo == 'H' &&
                                isPeeCeeATR
                            ) {
                                if (
                                    sessionStorage
                                        .getItem('deviceVersion')
                                        ?.startsWith('1')
                                ) {
                                    PortConnections['H'] = {
                                        type,
                                        index,
                                    }
                                    PortConnections['F1'] = {
                                        type,
                                        index,
                                    }
                                    PortConnections['F2'] = {
                                        type,
                                        index,
                                    }
                                } else {
                                    PortConnections['H'] = {
                                        type,
                                        index,
                                    }
                                    PortConnections['A2'] = {
                                        type,
                                        index,
                                    }
                                    PortConnections['F2'] = {
                                        type,
                                        index,
                                    }
                                }
                            } else if (
                                component.connectedTo == 'G' &&
                                isPeeCeeATR
                            ) {
                                if (
                                    sessionStorage
                                        .getItem('deviceVersion')
                                        ?.startsWith('1')
                                ) {
                                    PortConnections['G'] = {
                                        type,
                                        index,
                                    }
                                    PortConnections['E1'] = {
                                        type,
                                        index,
                                    }
                                    PortConnections['E2'] = {
                                        type,
                                        index,
                                    }
                                } else {
                                    PortConnections['G'] = {
                                        type,
                                        index,
                                    }
                                    PortConnections['C2'] = {
                                        type,
                                        index,
                                    }
                                    PortConnections['F1'] = {
                                        type,
                                        index,
                                    }
                                }
                            } else {
                                PortConnections[
                                    component.connectedTo[0] + '1'
                                ] = {
                                    type,
                                    index,
                                }
                                PortConnections[
                                    component.connectedTo[0] + '2'
                                ] = {
                                    type,
                                    index,
                                }
                            }
                        } else if (
                            component.connectedTo == 'MOTOR1' &&
                            isArmSHield
                        ) {
                            PortConnections['MOTOR1'] = {
                                type,
                                index,
                            }
                            PortConnections['M2'] = {
                                type,
                                index,
                            }
                            PortConnections['M3'] = {
                                type,
                                index,
                            }
                        }
                        // M1 that appears on the playShield is actually M1 and M2
                        else if (component.connectedTo == 'M1') {
                            PortConnections['M1'] = {
                                type,
                                index,
                            }
                            PortConnections['M2'] = {
                                type,
                                index,
                            }
                        } else if (component.connectedTo == 'M3') {
                            PortConnections['M3'] = {
                                type,
                                index,
                            }
                            PortConnections['M4'] = {
                                type,
                                index,
                            }
                        } else if (
                            (sessionStorage.getItem('connectedDevice') ===
                                'Klaw' &&
                                ['F1', 'F2'].includes(component.connectedTo)) ||
                            (sessionStorage.getItem('connectedDevice') ===
                                'Atr' &&
                                ['D1'].includes(component.connectedTo)) ||
                            (['Toki'].includes(
                                sessionStorage.getItem('connectedDevice')
                            ) &&
                                ['C1', 'C2', 'D1'].includes(
                                    component.connectedTo
                                ))
                        ) {
                            PortConnections[component.connectedTo] = {
                                type,
                                index,
                            }
                        } else {
                            PortConnections[component.connectedTo[0] + '1'] = {
                                type,
                                index,
                            }
                            PortConnections[component.connectedTo[0] + '2'] = {
                                type,
                                index,
                            }
                        }
                    }
                } else if (
                    [
                        'servo_motor',
                        'servo_motor_270',
                        'servo_motor_360',
                        'servo_motor_sg90',
                    ].includes(type)
                ) {
                    // if (sessionStorage.getItem('connectedDevice') !== 'Atr')
                    //     PortConnections[component.connectedTo] = { type, index }
                    if (component.connectedTo == 'S1') {
                        if (
                            sessionStorage.getItem('connectedDevice') === 'Atr'
                        ) {
                            PortConnections['C1'] = {
                                type,
                                index,
                            }
                        } else if (
                            JSON.parse(
                                sessionStorage.getItem('peeCeeATR') || 'false'
                            ) &&
                            sessionStorage
                                .getItem('deviceVersion')
                                ?.startsWith('1')
                        ) {
                            PortConnections['S1'] = {
                                type,
                                index,
                            }
                            PortConnections[component.connectedTo] = {
                                type,
                                index,
                            }
                        } else {
                            PortConnections['A1'] = {
                                type,
                                index,
                            }
                            PortConnections['S1'] = {
                                type,
                                index,
                            }
                        }
                    } else if (component.connectedTo == 'S2') {
                        if (
                            sessionStorage.getItem('connectedDevice') === 'Atr'
                        ) {
                            PortConnections['C2'] = {
                                type,
                                index,
                            }
                        } else if (
                            JSON.parse(
                                sessionStorage.getItem('peeCeeATR') || 'false'
                            ) &&
                            sessionStorage
                                .getItem('deviceVersion')
                                ?.startsWith('1')
                        ) {
                            PortConnections['S2'] = {
                                type,
                                index,
                            }
                            PortConnections[component.connectedTo] = {
                                type,
                                index,
                            }
                        } else {
                            PortConnections['C1'] = {
                                type,
                                index,
                            }
                            PortConnections['S2'] = {
                                type,
                                index,
                            }
                        }
                    } else if (component.connectedTo == 'P0') {
                        PortConnections['A1'] = {
                            type,
                            index,
                        }
                        PortConnections['P0'] = {
                            type,
                            index,
                        }
                    } else if (component.connectedTo == 'P1') {
                        PortConnections['B1'] = {
                            type,
                            index,
                        }
                        PortConnections['P1'] = {
                            type,
                            index,
                        }
                    } else if (component.connectedTo == 'P2') {
                        PortConnections['C1'] = {
                            type,
                            index,
                        }
                        PortConnections['P2'] = {
                            type,
                            index,
                        }
                    } else {
                        PortConnections[component.connectedTo] = { type, index }
                    }
                } else if (
                    type == 'joystick_v2' ||
                    (type == 'joystick' &&
                        sessionStorage.getItem('connectedDevice') ===
                            'Humanoid')
                ) {
                    const connectedDevice =
                        sessionStorage.getItem('connectedDevice')
                    if (component.connectedTo) {
                        const cfg = getJoystickWireConfig(
                            type,
                            connectedDevice,
                            component.connectedTo
                        )
                        if (cfg) {
                            // Per-wire model: wire A claims its axes pins, wire B
                            // claims its button pin. Each wire may have more than
                            // one candidate target (e.g. Ace: A or C for axes, B or
                            // D for button) - `wc.A`/`wc.B` hold the REAL port the
                            // wire actually landed on; resolveConnectedTarget finds
                            // the matching candidate (falling back to the first/
                            // preferred one for legacy components with no
                            // wireConnections map yet - drag-drop auto-connect,
                            // restored projects - which behave as before: both
                            // wires on, at their default candidate).
                            const wc = component.wireConnections || {
                                A: cfg.wires.A.targets[0].port,
                                B: cfg.wires.B.targets[0].port,
                            }
                            // Also claim the parent port - like led_1c does - so
                            // other components are blocked from it (IsOverPort
                            // only checks the exact port key). Byte-gen ignores a
                            // joystick_v2 parent-port entry.
                            if (wc.A) {
                                const targetA = resolveConnectedTarget(
                                    cfg.wires.A,
                                    wc.A
                                )
                                PortConnections[targetA.port] = {
                                    type,
                                    index,
                                }

                                targetA.occupies.forEach((pin, pinIndex) => {
                                    PortConnections[pin] = {
                                        type,
                                        index,
                                        joystickRole:
                                            pinIndex === 0 ? 'x' : 'y',
                                    }
                                })
                            }
                            if (wc.B) {
                                const targetB = resolveConnectedTarget(
                                    cfg.wires.B,
                                    wc.B
                                )
                                PortConnections[targetB.port] = {
                                    type,
                                    index,
                                }
                                targetB.occupies.forEach((pin) => {
                                    PortConnections[pin] = {
                                        type,
                                        index,
                                        joystickRole: 'button',
                                    }
                                })
                            }
                        } else if (component.connectedTo == 'A') {
                            PortConnections['A1'] = { type, index }
                            PortConnections['A2'] = { type, index }
                            PortConnections['B1'] = { type, index }
                        } else if (component.connectedTo == 'C') {
                            PortConnections['C1'] = { type, index }
                            PortConnections['C2'] = { type, index }
                            PortConnections['D1'] = { type, index }
                        }
                    }
                } else if (
                    type == 'led' ||
                    type == 'dip_switch' ||
                    type == 'dual_switch' ||
                    type == 'joystick' ||
                    type == 'tact_switch_2c'
                ) {
                    if (component.connectedTo) {
                        if (
                            component.connectedTo == 'A' ||
                            component.connectedTo == 'B' ||
                            component.connectedTo == 'C' ||
                            component.connectedTo == 'D' ||
                            component.connectedTo == 'E' ||
                            component.connectedTo == 'F'
                        ) {
                            PortConnections[`${component.connectedTo}1`] = {
                                type,
                                index,
                            }
                            PortConnections[`${component.connectedTo}2`] = {
                                type,
                                index,
                            }
                        }
                        PortConnections[component.connectedTo] = {
                            type,
                            index,
                        }
                    }
                } else {
                    if (
                        component.connectedTo == 'A' ||
                        component.connectedTo == 'B' ||
                        component.connectedTo == 'C' ||
                        component.connectedTo == 'D' ||
                        component.connectedTo == 'E' ||
                        component.connectedTo == 'F'
                    ) {
                        PortConnections[`${component.connectedTo}1`] = {
                            type,
                            index,
                        }
                    }
                    PortConnections[component.connectedTo] = {
                        type,
                        index,
                        // signalType: SensorObj.signalType,
                    }
                }
            })
        })
        return PortConnections
    }

    /**
     * Thin wrapper over computeAutoDropPinConnections (PinMaps.js) bound to this
     * workspace's live component map. Shared with the drag preview in
     * Connections.js so hover and drop agree on where each + / - wire lands.
     * @param  {string} type The component type
     * @param  {string} droppedPort The port the component was dropped on
     * @param  {string} device The connected device
     * @param  {?{type:string,index:number}} skip Component to exclude from the
     *         occupancy scan (the one being moved/placed)
     * @return {?{pinConnections:object, allConnected:boolean}}
     */
    findAutoDropPinConnections(type, droppedPort, device, skip) {
        return computeAutoDropPinConnections(
            Ports,
            type,
            droppedPort,
            device,
            this.props.workspace.components || {},
            skip
        )
    }

    // Warn (via the snackbar) when a freshly auto-dropped component couldn't
    // claim a + and/or - power slot because they're all occupied. Assembly
    // (sandbox) has no tutorial message bar, so reuse the existing AI-model
    // popup snackbar (showAiModelPopUp) — the equivalent of AssemblyTwo's
    // showTutorialMessage.
    notifyPowerPinsOccupied(pinConnections, cfg) {
        const missing = ['+', '-'].filter(
            (pk) => cfg.pins[pk] && !pinConnections[pk]
        )
        if (!missing.length) return
        const label = missing.join(' / ')
        window.appState?.showAiModelPopUp?.({
            elementKey: `All ${label} power pins are occupied. Disconnect one to wire this component's ${label}.`,
            text: true,
            time: 4000,
        })
    }

    /**
     * Update the position of an old component
     * @param  {number} left The new left
     * @param  {number} top  The new top
     */
    updateOldComponent(left, top) {
        var { workspace } = this.props
        var item = DraggingInfo.draggingComponentOld

        const movedComp = workspace.components[item.type][item.index]
        movedComp.top = top
        movedComp.left = left

        const joystickDeviceForMove = sessionStorage.getItem('connectedDevice')
        const hasJoystickWiring =
            isJoystickWireType(item.type) &&
            !!getJoystickWireConfig(
                item.type,
                joystickDeviceForMove,
                DraggingInfo.newComponentPort || movedComp.connectedTo
            )

        if (DraggingInfo.newComponentPort != undefined) {
            if (hasJoystickWiring) {
                movedComp.wireConnections = computeJoystickDropWires(
                    movedComp.wireConnections,
                    this.props.appState.assembly.PortConnections,
                    joystickDeviceForMove,
                    DraggingInfo.newComponentPort
                )
                movedComp.connectedTo =
                    movedComp.wireConnections.A ||
                    movedComp.wireConnections.B ||
                    undefined
            } else {
                movedComp.connectedTo = DraggingInfo.newComponentPort
            }
        } else if (hasJoystickWiring) {
            // Dropped away from any port: fully disconnect so state stays consistent.
            movedComp.wireConnections = { A: null, B: null }
            movedComp.connectedTo = undefined
        }
        const comp = workspace.components[item.type][item.index]
        const cfg = getHardwareWireConfig(
            item.type,
            sessionStorage.getItem('connectedDevice')
        )
        const connectedDevice = sessionStorage.getItem('connectedDevice')
        if (
            cfg &&
            (connectedDevice === 'Poki' || connectedDevice === 'woofKit')
        ) {
            // Poki: always re-run auto-drop routing on drop so + / - settle on
            // free pins based on current occupancy. The stored pinConnections
            // still point at the OLD port (removeConnection only cleared
            // connectedTo), so recompute — excluding this instance — to match
            // the live drag preview exactly.
            const result = this.findAutoDropPinConnections(
                item.type,
                DraggingInfo.newComponentPort,
                connectedDevice,
                { type: item.type, index: item.index }
            )
            if (result && !result.allConnected) {
                // No free + / - slot → invalid connection. Reject it entirely:
                // stay disconnected (connectedTo was cleared on drag start) and
                // drop any stale per-pin wiring so no connection state persists.
                delete comp.connectedTo
                comp.pinConnections = {}
                this.notifyPowerPinsOccupied(result.pinConnections, cfg)
            } else if (result) {
                comp.pinConnections = result.pinConnections
                comp.connectedTo = DraggingInfo.newComponentPort
            }
        } else if (cfg && connectedDevice === 'Toki') {
            const hasManualPins =
                comp.pinConnections &&
                Object.values(comp.pinConnections).some((v) => v !== null)
            if (hasManualPins) {
                // Preserve the user's manual per-pin wiring.
                // Re-derive connectedTo from the signal pin so redux stays in sync.
                const signalPinKey =
                    Object.keys(cfg.pins).find((k) => cfg.pins[k].isSignal) ||
                    Object.keys(cfg.pins).find((k) => k !== '+' && k !== '-')
                const signalPort =
                    signalPinKey && comp.pinConnections[signalPinKey]
                comp.connectedTo = signalPort || DraggingInfo.newComponentPort
            } else {
                // No prior wiring — auto-connect through the occupancy-aware
                // router (same as Poki / a fresh drop) so each + / - lands on a
                // free power pin instead of blindly stacking on the dropped port.
                // Exclude this instance from the occupancy scan.
                const result = this.findAutoDropPinConnections(
                    item.type,
                    DraggingInfo.newComponentPort,
                    connectedDevice,
                    { type: item.type, index: item.index }
                )
                if (result && !result.allConnected) {
                    delete comp.connectedTo
                    comp.pinConnections = {}
                    this.notifyPowerPinsOccupied(result.pinConnections, cfg)
                } else if (result) {
                    comp.pinConnections = result.pinConnections
                    comp.connectedTo = DraggingInfo.newComponentPort
                }
            }
        } else {
            comp.connectedTo = DraggingInfo.newComponentPort
        }
        this.props.update(workspace)

        const PortConnections = this.upDatePortConnectionsRedux()

        this.props.updatePort(PortConnections)

        // Re-open the magnifier after moving an existing wired joystick_v2.
        if (hasJoystickWiring && window.assemblyAppState) {
            window.assemblyAppState.openMagnifier(item.type, item.index)
        }
    }
    /**
     * Add a new component to workspace. Also if DraggingInfo.newComponentPort is
     * defined connect the new component to that port.
     * @param  {string} type The type of the component
     * @param  {number} left The left offset
     * @param  {number} top  The top offset
     */
    newComponent(type, left, top) {
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        let deviceVersion = sessionStorage.getItem('deviceVersion')

        // AI-1 cannot be added without a connected, supported device: show the
        // warning and block the drop so nothing lands on the board
        if (type === 'pcAiTool') {
            const isDeviceConnected = !!this.props?.webSerial?.isConnected
            const isUnsupportedFirmware =
                isDeviceConnected &&
                !isAi1ShowCondition({ connectedDevice, deviceVersion })
            if (!isDeviceConnected || isUnsupportedFirmware) {
                DraggingInfo.newComponentPort = null
                this.props.setAssemblyPageAi({
                    ...this.props.prop.assemblyPageAi,
                    isShowDeviceNotConnectPopUp: !isDeviceConnected,
                    isShowLowerVersionPopup: isUnsupportedFirmware,
                })
                return
            }
        }

        if (connectedDevice == 'Ace') {
            if (!sessionStorage.getItem('deviceVersion')?.startsWith('1')) {
                this.props.handleReadBytes()
            } else {
                this.props.stopPA()
            }
        } else {
            this.props.stopPA()
        }

        let componentsDataSensor = JSON.parse(
            sessionStorage.getItem('concept')
        ).counter
        var { workspace } = this.props
        if (!workspace.components[type]) workspace.components[type] = []
        var component = { left: left, top: top } //IMP

        if (DraggingInfo.newComponentPort) {
            component.connectedTo = DraggingInfo.newComponentPort
            // Multi-pin components (Poki AND Toki) auto-drop through the shared
            // occupancy-aware router: each + / - lands on a free power pin (the
            // dropped port's own pin first, then the pool) while the signal pins wire
            // to the dropped port. This enforces one wire per + / - pin so a board
            // power pin can't be claimed by two components. On Toki the Poki-only
            // fallbackPins rails simply aren't in PortData, so the pool is the real
            // A1/A2/servo power pins. If no free + / - slot remains anywhere the drop
            // is rejected — matching the suppressed drag highlight.
            const cfg = getHardwareWireConfig(type, connectedDevice)
            if (
                cfg &&
                (connectedDevice === 'Poki' ||
                    connectedDevice === 'woofKit' ||
                    connectedDevice === 'Toki')
            ) {
                const result = this.findAutoDropPinConnections(
                    type,
                    DraggingInfo.newComponentPort,
                    connectedDevice,
                    null
                )
                if (result && !result.allConnected) {
                    // No free + / - slot → invalid connection. Reject it entirely:
                    // leave the component unconnected (no connectedTo / pinConnections)
                    // so no connection state is written, and just warn the user.
                    delete component.connectedTo
                    this.notifyPowerPinsOccupied(result.pinConnections, cfg)
                } else if (result) {
                    component.pinConnections = result.pinConnections
                }
            }
            DraggingInfo.newComponentPort = null
        }
        // joystick_v2 on wire-enabled devices: keep the drag-drop auto-connect but
        // track wires per-wire so the magnifier can re-route each independently,
        // and only auto-connect a wire whose target port is free (partial connect
        // when e.g. port A is already taken). A drop away from a port leaves both
        // unwired.
        const droppedPortForJoystick = component.connectedTo
        const hasJoystickWiring =
            isJoystickWireType(type) &&
            !!getJoystickWireConfig(
                type,
                connectedDevice,
                droppedPortForJoystick
            )
        if (hasJoystickWiring) {
            component.wireConnections = droppedPortForJoystick
                ? computeJoystickDropWires(
                      undefined,
                      this.props.appState.assembly.PortConnections,
                      connectedDevice,
                      droppedPortForJoystick
                  )
                : { A: null, B: null }
            component.connectedTo =
                component.wireConnections.A ||
                component.wireConnections.B ||
                undefined
        }
        const newIndex = workspace.components[type].length
        workspace.components[type].push(component) //IMP
        // REDUX
        this.props.update(workspace)
        sessionStorage.setItem(
            'dualsplitter',
            JSON.stringify(workspace.components)
        )
        const PortConnections = this.upDatePortConnectionsRedux()
        this.props.updatePort(PortConnections)
        // After the drop settles, open the magnifier to hint that wiring can be
        // changed (per product decision: auto-connect stays, magnifier also opens).
        // TEMP DIAGNOSTIC - remove after fix.
        if (isJoystickWireType(type))
            console.log('[JSDBG] addComponent drop', {
                type,
                connectedDevice,
                deviceVersion,
                droppedPortForJoystick,
                hasJoystickWiring,
                hasAppState: !!window.assemblyAppState,
                wireConnections: component.wireConnections,
            })
        if (hasJoystickWiring && window.assemblyAppState) {
            window.assemblyAppState.openMagnifier(type, newIndex)
        }

        if (
            [
                'servo_motor',
                'servo_motor_270',
                'servo_motor_360',
                'servo_motor_sg90',
            ].includes(type) &&
            this.props.onAccessorySelect
        ) {
            this.props.onAccessorySelect({
                type,
                index: newIndex,
                connectedTo: component.connectedTo,
            })
        }

        //this code open the assembly page ai selection screen
        if (type === 'pcAiTool') {
            let assemblyPageAi = { ...this.props.prop.assemblyPageAi }
            assemblyPageAi.isShowAiSelectContainer = true

            try {
                let bytes = appAiBytesGeneration('aiVersionByte')
                if (this.props.webSerial.isConnected) {
                    this.props.handelAiContainerLoader(true)
                    this.props.worker.postMessage({
                        type: 'WriteArrayFormat1310',
                        value: bytes,
                    })

                    this.props.aiContainerLoaderTimeOutRef.current = setTimeout(
                        () => {
                            this.props.handelAiContainerLoader(false)
                        },
                        5000
                    )
                }
            } catch (e) {
                console.log(e)
            }

            this.props.setAssemblyPageAi(assemblyPageAi)
        }
        //setAssemblyPageAi
    }
    /**
     * Connect a old component to a port in workspace (on drop)
     * @param  {AssemblyComponent} item
     * @param  {string} port The port
     */
    workspaceConnect(item, port) {
        var { workspace } = this.props
        workspace.components[item.type][item.index].connectedTo = port
        this.props.update(workspace)

        if (
            [
                'servo_motor',
                'servo_motor_270',
                'servo_motor_360',
                'servo_motor_sg90',
            ].includes(item.type) &&
            this.props.onAccessorySelect
        ) {
            this.props.onAccessorySelect({
                type: item.type,
                index: item.index,
                connectedTo: port,
            })
        }
    }
    /**
     * Remove connection of old component
     * @param  {AssemblyComponent} item
     */
    removeConnection(item) {
        var { workspace } = this.props
        if (workspace.components[item.type][item.index].connectedTo) {
            var obj = workspace.components[item.type][item.index]
            delete obj.connectedTo
            if (obj.pinConnections) delete obj.pinConnections
            if (obj.wireConnections) delete obj.wireConnections
        }
        this.props.update(workspace)
        let componentsDataSensor = JSON.parse(
            sessionStorage.getItem('concept')
        ).counter

        const PortConnections = this.upDatePortConnectionsRedux()
        this.props.updatePort(PortConnections)
    }

    closeUsb = () => {
        var c = document.getElementById('assemblyConnections')
        var d = document.getElementById('biboxClass')
        var e = document.getElementById('connectPort')

        c.style.zIndex = 2
        d.style.zIndex = 2
        e.style.zIndex = 2
        this.setState({ usbOpen: false })
    }
    render() {
        var count = 0
        if (this.state.detected == true) {
            var imageURL = 'images/Learn/ble_connection.png'
        } else {
            imageURL = 'images/Learn/ble_disconnection.png'
        }
        var usbDetectionModel = (
            <Modal isOpen={this.state.usbOpen} style={customStyles}>
                <img
                    onClick={this.closeUsb}
                    className="closeconceptModal"
                    src={renderPrgImage('close')}
                ></img>
                <div className="connectconceptMsg">
                    <p>Device not connected..</p>
                    <button>
                        {' '}
                        <Link
                            style={{ textDecoration: 'none', color: 'black' }}
                            to="/deviceSelection"
                        >
                            Reconnect
                        </Link>
                    </button>
                </div>
            </Modal>
        )
        const { connectDropTarget, removeFromWorkspace } = this.props
        const { bibox, components, offset, scale } = this.props.workspace
        var { PortConnections } = this.props.appState.assembly

        return connectDropTarget(
            <div
                id="workSpace"
                ref={this.workSpaceRef}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                }}
            >
                {/* SHOWS DEVICE IMG ACE, HUMANOID, TEARN */}
                <Bibox
                    left={(bibox.left + offset.left) * scale}
                    top={(bibox.top + offset.top) * scale}
                    scale={scale}
                    workspaceConnect={this.workspaceConnect}
                    switch1={this.props.switch1}
                    switch2={this.props.switch2}
                    responceTp0={this.props.responceTp0}
                    responceTp1={this.props.responceTp1}
                    responceTp2={this.props.responceTp2}
                    mic={this.props.mic}
                    props={this.props}
                    removeFromWorkspace={removeFromWorkspace}
                    // Ports
                    rangeA1={this.props.rangeA1}
                    rangeA2={this.props.rangeA2}
                    tactswitch={this.props.tactswitch}
                    temp={this.props.temp}
                    gas={this.props.gas}
                    zero={this.props.zero}
                    one={this.props.one}
                    two={this.props.two}
                    shield={this.props.shield}
                    setShield={this.props.setShield}
                    armShield={this.props.armShield}
                    setArmShield={this.props.setArmShield}
                    peeCeeATR={this.props.peeCeeATR}
                    setPeeCeeATR={this.props.setPeeCeeATR}
                />

                {/* USB detection is remove and the Zindex is also change from componentDidmount */}
                {/* {usbDetectionModel} */}

                {Object.keys(components).map((key) => {
                    return (
                        <div key={key}>
                            {components[key].map((component, index) => {
                                const { left, top, connectedTo } = component
                                return (
                                    <div
                                        key={index}
                                        onClick={() => {
                                            if (this.props.onAccessorySelect) {
                                                this.props.onAccessorySelect({
                                                    type: key,
                                                    index,
                                                    connectedTo,
                                                })
                                            }
                                        }}
                                    >
                                        <Component1
                                            webSerial={this.props.webSerial}
                                            aiVersion={this.props.aiVersion}
                                            key={index}
                                            type={key}
                                            index={index}
                                            prop={this.props.prop}
                                            left={(offset.left + left) * scale}
                                            top={(offset.top + top) * scale}
                                            scale={scale}
                                            connectedTo={connectedTo}
                                            wireConnections={
                                                component.wireConnections
                                            }
                                            magnifier={this.props.magnifier}
                                            activeWire={this.props.activeWire}
                                            fixed={component.fixed}
                                            appState={this.props.appState}
                                            isPcActive={this.props.isPcActive}
                                            isReading={this.props.isReading}
                                            removeFromWorkspace={
                                                removeFromWorkspace
                                            }
                                            setAssemblyPageAi={
                                                this.props.setAssemblyPageAi
                                            }
                                            removeConnection={
                                                this.removeConnection
                                            }
                                            touch_pad={this.props.touch_pad}
                                            touch_pad2={this.props.touch_pad2}
                                            rangeA1={this.props.rangeA1}
                                            rangeA2={this.props.rangeA2}
                                            rangeB1={this.props.rangeB1}
                                            rangeB2={this.props.rangeB2}
                                            rangeC1={this.props.rangeC1}
                                            rangeC2={this.props.rangeC2}
                                            rangeD1={this.props.rangeD1}
                                            rangeD2={this.props.rangeD2}
                                            rangeE1={this.props.rangeE1}
                                            rangeE2={this.props.rangeE2}
                                            rangeF1={this.props.rangeF1}
                                            rangeF2={this.props.rangeF2}
                                            rangeG1={this.props.rangeG1}
                                            rangeG2={this.props.rangeG2}
                                            rangeservo_motor1={
                                                this.props.rangeservo_motor1
                                            }
                                            rangeservo_motor2={
                                                this.props.rangeservo_motor2
                                            }
                                            tactswitch={this.props.tactswitch}
                                            temp={this.props.temp}
                                            gas={this.props.gas}
                                            one={this.props.one}
                                            two={this.props.two}
                                            shield={this.props.shield}
                                            setShield={this.props.setShield}
                                            armShield={this.props.armShield}
                                            setArmShield={
                                                this.props.setArmShield
                                            }
                                            peeCeeATR={this.props.peeCeeATR}
                                            setPeeCeeATR={
                                                this.props.setPeeCeeATR
                                            }
                                            accelerometer_X={
                                                this.props.accelerometer_X
                                            }
                                            accelerometer_Y={
                                                this.props.accelerometer_Y
                                            }
                                            accelerometer_Z={
                                                this.props.accelerometer_Z
                                            }
                                            gyro_X={this.props.gyro_X}
                                            gyro_Y={this.props.gyro_Y}
                                            gyro_Z={this.props.gyro_Z}
                                            magnetometer_X={
                                                this.props.magnetometer_X
                                            }
                                            magnetometer_Y={
                                                this.props.magnetometer_Y
                                            }
                                            magnetometer_Z={
                                                this.props.magnetometer_Z
                                            }
                                            red={this.props.red}
                                            green={this.props.green}
                                            blue={this.props.blue}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    )
                })}

                {localStorage.getItem('programMode') == 'learn' ? (
                    <div
                        style={{
                            height: '10%',
                            width: '65%',
                            border: '2px solid #bed5fa',
                            backgroundColor: 'white',
                            borderRadius: '20px',
                            bottom: '3%',
                            left: '10%',
                            position: 'inherit',
                        }}
                    >
                        <h3 style={{ marginLeft: '20px', marginTop: '2px' }}>
                            {Object.entries(this.state.tutorialDesc).map(
                                ([key, value]) => {
                                    if (PortConnections[key]) {
                                        if (
                                            PortConnections[key].type == value
                                        ) {
                                        }
                                    } else {
                                        if (count == 0) {
                                            count++
                                            this.props.nextVisbility('hidden')
                                            return (
                                                <div key={key}>
                                                    {' '}
                                                    Drag &amp; connect {
                                                        value
                                                    }{' '}
                                                    to {key} port
                                                </div>
                                            )
                                        }
                                    }
                                }
                            )}
                            {count == 0 ? (
                                <p>
                                    {this.props.nextVisbility('visible')}
                                    <div>Click on next</div>
                                </p>
                            ) : (
                                ''
                            )}
                        </h3>
                    </div>
                ) : (
                    <div> </div>
                )}
            </div>
        )
    }
}

export default DropTarget(
    [ItemTypes.BIBOX, ItemTypes.COMPONENT],
    workspaceTarget,
    (connect) => ({
        connectDropTarget: connect.dropTarget(),
    })
)(Workspace)
